import React, { Component } from 'react';
import { Container, Row } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import RegistrationHeader from '../registration/RegistrationHeader';
import PersonConsentBody from './PersonConsentBody';
import FavIcon from '../app/FavIcon';
import { entityGet } from '../entity/Entity';
import * as RegisterActions from '../registration/RegisterActions';

class PersonConsent extends Component {
  constructor(props) {
    super(props);

    this.unionid = this.props.match.params.unionid;
    this.clubid = this.props.match.params.clubid;
    this.publicpersonid = this.props.match.params.publicpersonid;

    if (this.unionid && this.clubid) {
      this.getClub();
    }
  }


  getClub() {
    this.props.fetchingClub()
    const parameters = {'UnionId': this.unionid, 'ClubId': this.clubid};
    entityGet("Club", parameters, this.props.fetchClubSuccess, this.props.fetchClubFailure);
  }

  render() {
    var formClass = (this.props.submitting) ? 'loading' : 'done';

    return (
      <div className="App">
        <FavIcon isKNVB={this.unionid === 'KNVB'} />

        <Container fluid={true}>
          <Row>
            <Container fluid={true} className={"ContentForm Body " + formClass}  >
              <RegistrationHeader
                unionid={this.unionid}
                clubName={this.props.clubName}
                clubCity={this.props.clubCity}
                clubLogo={this.props.clubLogo} />

              <PersonConsentBody unionid={this.unionid} clubid={this.clubid} publicpersonid={this.publicpersonid} />
            </Container>
          </Row>
          <Row>
            <div className="ml-auto">
              <img className="sl-logo" src="/img/sportlink_logo.png" alt="Sportlink logo" />
            </div>
          </Row>
        </Container>
      </div>
    );
  }
}

PersonConsent.propTypes = {
  submitting: PropTypes.bool.isRequired,
  clubName: PropTypes.string,
  clubLogo: PropTypes.string,
  clubCity: PropTypes.string,

  fetchingClub: PropTypes.func,
  fetchClubSuccess: PropTypes.func,
  fetchClubFailure: PropTypes.func,

  match: PropTypes.shape({
     params: PropTypes.shape({
       unionid: PropTypes.string.isRequired,
       clubid: PropTypes.string.isRequired,
       publicpersonid: PropTypes.string.isRequired,
     })
   }),
}

const mapStateToProps = state => ({
  submitting: state.personconsent.submitting,
  clubName: state.personconsent.club.Name,
  clubLogo: state.personconsent.club.Logo,
  clubCity: state.personconsent.club.Address.City,
})

const mapDispatchToProps = {
  fetchingClub: RegisterActions.fetchingClub,
  fetchClubSuccess: RegisterActions.fetchClubSuccess,
  fetchClubFailure: RegisterActions.fetchClubFailure
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PersonConsent)



// WEBPACK FOOTER //
// ./src/personconsent/PersonConsent.jsx